import { USER_ROLES } from 'swag-common/constants/user-roles';
export const isOpsTeamUser = userRole => userRole === USER_ROLES.OPS_TEAM;